module.exports = __webpack_public_path__ + "img/hotelFamily-5.32c46c6a.jpg";